import React, {Component} from 'react';
import {AJAX, hidePreloader, setUrlSinglePageApp, showPreloader} from "../functions";
import {showPopupWithGoBack} from "../popups/PopupWithGoBack";
import {withRouter} from "react-router";

class TermsAndConditionsPage extends Component {
    state = {terms:''};
    constructor(props) {
        super(props);
        this.getTerms = this.getTerms.bind(this);

        setUrlSinglePageApp(this.props.history.location.pathname);
    }

    componentDidMount() {
        this.getTerms();
    }

    getTerms() {
        let t = this;
        AJAX(bm_ajax_url, 'POST', {action: 'api/booking/terms_conditions'}, {
            response_json: true,
            func_waiting: showPreloader,
            func_callback: function (resp) {
                hidePreloader();
                if (resp.success === 1 && Object.keys(resp.data).length) {
                   t.setState({terms: resp.data.content});
                } else {
                    if (resp.errors && 'main' in resp.errors && Object.keys(resp.errors.main).length) {
                        showPopupWithGoBack(resp.errors.main);
                    }
                }
            },
            func_error: function (resp) {
                hidePreloader();
                showPopupWithGoBack(resp.message);
            }
        });
    }

    render() {
        return (
            <div className="value-space">
                <div className="row terms-and-conditions-page">
                    <div className="offset-1 col-10">
                        <h1 className="my-4">Terms and Conditions</h1>
                        <div dangerouslySetInnerHTML={{__html: this.state.terms}} />
                    </div>
                </div>
            </div>
        );
    }
}

const TermsAndConditionsPageR = withRouter(TermsAndConditionsPage);
export default TermsAndConditionsPageR;